// extracted by mini-css-extract-plugin
export default {"allIconsWrapper":"AllIcons_allIconsWrapper__NEwgP","tempSVGIcon":"AllIcons_tempSVGIcon__Q5L8w","iconLabel":"AllIcons_iconLabel__anbBj","copyLayer":"AllIcons_copyLayer__yKNUS"};